<template>
  <div class="select-item">
    <div class="move-box">
      <div class="move-box-drag">
        <div class="select-item-temp" v-for="(item,index) in dataset" :key="item.key">
          <i class="icon iconfont iconicon_drag_order drag tableIconHover"></i>
          <el-input v-model="dataset[index].value" size="large" maxlength="100" :disabled="dataset[index].disabled" placeholder="请输入选项名称" clearable>
          </el-input>
          <div class="last-box">
            <span class="close-box" v-if="!isEdit" @click="delItem(index)"></span>
          </div>
        </div>
      </div>
      <div class="key-button " @click="addItem">
        <p class="text-blue"><i class="icon iconfont iconicon_new_subproject"></i>添加选项</p>
      </div>
    </div>
  </div>
</template>
<script>
import Sortable from 'sortablejs'
import bus from '@/bus'
import ColorPopover from '../../colorPopover'
export default {
  props: ['value', 'isEdit'],
  components: {
    ColorPopover
  },
  data() {
    return {
      dataset: [],
    }
  },
  mounted() {
    this.init()
  },
  watch: {
    dataset: {
      handler() {
        this.$emit('input', this.dataset.map(res => res.value))
        bus.$emit('changeSelect', this.dataset)
      },
      deep: true
    }
  },
  methods: {
    init() {
      this.dataset = []
      if (this.value && this.value.length > 0) {
        this.dataset = JSON.parse(JSON.stringify(this.value.map(res => {
          return {
            key: Math.random() + '' + new Date().getTime(),
            value: res,
            disabled: true
          }
        })))
      }
      if (this.dataset.length === 0) { return }
      this.eleInit()
    },
    eleInit() {
      let eles = document.getElementsByClassName('move-box-drag')[0]
      let _this = this
      new Sortable(eles, {
        handle: '.drag',
        animation: 150,
        ghostClass: 'blue-background-class',
        onChoose(e) {
          e.item.style.border = '2px dashed #2682FF'
        },
        onUnchoose(e) {
          e.item.style['border'] = '0 none'
          e.item.style['border-bottom'] = '1px solid rgba(32, 32, 32, 0.16)'
        },
        onEnd(e) {
          _this.onListEnd(e)
        }
      });
    },
    onListEnd(e) {
      let data = JSON.parse(JSON.stringify(this.dataset))
      let oldIndex = e.oldDraggableIndex
      let newIndex = e.newDraggableIndex
      let item = data.splice(oldIndex, 1)[0]
      data.splice(newIndex, 0, item)
      this.dataset = JSON.parse(JSON.stringify(data))
    },
    addItem() {
      if (this.dataset.length === 50) {
        this.$error({ message: '选项数量不能超过50', type: 'success' });
        return
      }
      this.dataset.push({ key: this.uuid(), value: '' })
      this.eleInit()
    },
    delItem(index) {
      this.dataset.splice(index, 1)
    },
    colorChange(item) {

    }
  }
}
</script>
<style lang="scss">
.select-item {
  border: 1px solid rgba(32, 32, 32, 0.16);
  border-radius: 4px;
  .key-button {
    height: 48px;
    line-height: 48px;
    box-sizing: border-box;
    margin-top: 0;
    font-size: 14px;
    color: rgba(32, 32, 32, 0.8);
    i {
      font-size: 14px;
      margin-right: 9px;
    }
    p {
      text-align: center;
    }
  }
  .item-count {
    padding: 8px 0;
    font-size: 12px;
  }
  .move-box {
    // overflow-x: hidden;
    // max-height: 300px;
  }
  .select-item-temp {
    display: flex;
    align-items: center;
    padding: 0 16px;
    border-bottom: 1px solid rgba(32, 32, 32, 0.16);
    height: 48px;
    .drag {
      font-size: 14px;
      color: rgba(32, 32, 40, 0.4);
    }
    .last-box {
      display: flex;
      align-items: center;
      .close-box {
        width: 13px;
        height: 13px;
        background-color: #EE574A;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        margin-left: 17px;
        cursor: pointer;
        &::after {
          content: '';
          display: block;
          width: 6px;
          height: 2px;
          background-color: #fff;
          border-radius: 1px;
        }
      }
    }
    .el-input__inner {
      border: 0 none !important;
    }
  }
}
</style>
